import styled from "styled-components";

export const InputContainer = styled.div`
  margin-top: 10px !important;
  margin-bottom: 20px !important;
`;